/* eslint-disable no-console */
// these functions are used for improving mobile devices performance to persist form values without retaining the dom nodes when not in use
// ? why only classbased forms need this? because v2 approach already saves everything in redux state and not local state

const SESSION_KEY = 'legacyFormState';

export const resetFormValues = () => {
  if (!window.sessionStorage) {
    console.log('not browser env');
    return;
  }
  window.sessionStorage.removeItem(SESSION_KEY);
};

export const saveFormValuesToSession = (stateObject: any): void => {
  if (!window.sessionStorage) {
    console.log('not browser env');
    return;
  }
  const isDesktop = window.matchMedia('(min-width: 1024px)').matches;
  if (isDesktop) return;
  if (!stateObject) {
    console.log('invalid state to save');
    return;
  }

  window.sessionStorage.setItem(SESSION_KEY, JSON.stringify(stateObject));
};

export const getFormValuesFromSession = () => {
  if (!window.sessionStorage) {
    console.log('not browser env');
    return null;
  }
  const sessionValue = window.sessionStorage.getItem(SESSION_KEY);
  if (!sessionValue) return null;
  try {
    const savedStateObject = JSON.parse(sessionValue);
    resetFormValues();
    return savedStateObject;
  } catch (e) {
    // Handle parsing errors
    console.error('Failed to parse saved state:', e);
    return null;
  }
};
